import callAPiBase from './base';

const messageTagsApi = {
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/api/tags/message',
      method: 'POST',
      useToken: true,
      data,
    }),
  // v2: message ids are strings ('<epoch ms>#<random>') — '#' must be encoded
  delete: ({
    ID,
    messageID,
    Room,
  }: {
    ID: string;
    messageID: string;
    Room: string;
  }) =>
    callAPiBase({
      endpoint: `/api/tags/message?ID=${ID}&id=${encodeURIComponent(
        messageID,
      )}&room=${encodeURIComponent(Room)}`,
      method: 'DELETE',
      useToken: true,
    }),
};

export { messageTagsApi };
export default messageTagsApi;
